(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/order-home/confirmation/page.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/order-home/confirmation/page.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  Image
} = svs.content.image_v2;
const {
  useEffect
} = React;
const {
  BubbleInfo
} = svs.tur.bubbleInfo.components;
const Button = svs.ui.ReactButton;
const {
  Card,
  CardBody
} = svs.ui.ReactCard;
const {
  Loader
} = svs.ticketsOrderHome.components;
const {
  CustomerAddressInformationComponent
} = svs.ticketsOrderHome.orderHome.components;
const {
  useConfirmedOrder,
  useCustomerPreferences
} = svs.ticketsOrderHome.hooks;
const {
  CHOOSE
} = svs.ticketsOrderHome.routes.ORDER_HOME;
const formatCurrency = svs.utils.format.Currency;
const {
  toTitleCase
} = svs.ticketsOrderHome.utils;
const {
  GIFT: {
    MESSAGE,
    MESSAGE_NO_NAME,
    TITLE: GIFT_TITLE
  },
  HOME: {
    TITLE: HOME_TITLE
  }
} = svs.ticketsOrderHome.utils.constants.orderHomeConfirmation;
const getBubbleWinTexts = _ref => {
  let {
    isGift,
    giftAddress
  } = _ref;
  if (!isGift) {
    return {
      header: HOME_TITLE
    };
  }
  const bubbleWinText = giftAddress !== null && giftAddress !== void 0 && giftAddress.name ? MESSAGE.replace('{RECEIVER_NAME}', toTitleCase(giftAddress.name)) : MESSAGE_NO_NAME;
  return {
    header: GIFT_TITLE,
    bubbleWinText
  };
};
setGlobal('svs.ticketsOrderHome.pages.Confirmation', function () {
  let {
    history,
    match
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    confirmationCards = []
  } = svs.ticketsOrderHome.data.config.orderHome;
  const {
    loading: loadingOrder,
    tickets,
    totalOrderPrice,
    shippingCost,
    giftAddress,
    isGift
  } = useConfirmedOrder(match === null || match === void 0 ? void 0 : match.params.referenceId);
  const {
    data,
    error,
    loading: loadingAddress
  } = useCustomerPreferences();
  const loading = loadingAddress || loadingOrder;
  const {
    header,
    bubbleWinText = null
  } = getBubbleWinTexts({
    isGift,
    giftAddress
  });
  const isMissingAddress = isGift ? !giftAddress : Boolean(error);
  useEffect(() => {
    if (!loading && tickets.length === 0) {
      history === null || history === void 0 || history.push(CHOOSE);
    }
  }, [loading, tickets, history]);
  const handleBuyTicketsOnClick = e => {
    e.preventDefault();
    const label = isGift ? 'send_to_other' : 'send_to_me';
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeBuyTicketClick(label);
    history === null || history === void 0 || history.push(CHOOSE);
  };
  const handletransactionsAccountHistoryClick = e => {
    e.preventDefault();
    const accountHistoryUrl = svs.core.urlMapping.get('transactionsAccountHistory');
    svs.utils.url.navigate(accountHistoryUrl);
  };
  const handleCardOnClick = _ref2 => {
    let {
      link,
      linkOutsideModule
    } = _ref2;
    if (linkOutsideModule) {
      svs.utils.url.navigate("".concat(link));
    } else {
      history.push("".concat(link));
    }
  };
  return React.createElement("div", null, loading && React.createElement(Loader, null), React.createElement("div", {
    className: "tg-preview-bubble-info"
  }, !loading && React.createElement(BubbleInfo, {
    className: "bubble-info-container",
    header: header
  }, bubbleWinText && React.createElement("span", {
    className: "f-content"
  }, bubbleWinText))), React.createElement("div", {
    className: "order-home-confirmation-page"
  }, React.createElement("div", {
    className: "order-home-confirmation-body bg-white u-flex-justify-content-center align-center padding-left-1 padding-right-1"
  }, React.createElement("div", {
    className: "padding-v-1 border-bottom u-text-left"
  }, React.createElement("h3", {
    className: "fw-500 margin-bottom-2"
  }, "Best\xE4llningen levereras inom n\xE5gra dagar till:"), !loadingOrder && React.createElement(CustomerAddressInformationComponent, {
    className: "margin-bottom-2",
    data: giftAddress || data,
    error: isMissingAddress,
    LoaderComponent: false,
    loading: loadingAddress
  }), React.createElement("p", {
    className: "f-content"
  }, "Du kan se din best\xE4llning p\xE5 din", ' ', React.createElement("a", {
    href: "#",
    onClick: handletransactionsAccountHistoryClick
  }, React.createElement("span", {
    className: "u-text-decoration-no-underline"
  }, "kontohistorik.")))), React.createElement("div", {
    className: "border-bottom u-text-left padding-bottom-1"
  }, React.createElement("h3", {
    className: "fw-500 margin-top-2"
  }, "Din best\xE4llning:"), React.createElement("div", null, React.createElement("div", {
    className: "summary-row"
  }, React.createElement("div", {
    className: "box-1"
  }, React.createElement("p", {
    className: "f-content f-bold margin-bottom-half"
  }, "Produkt:")), React.createElement("div", {
    className: "box-2"
  }, React.createElement("p", {
    className: "f-content u-text-right f-bold margin-bottom-half"
  }, "Antal (st):")), React.createElement("div", {
    className: "box-3"
  }, React.createElement("p", {
    className: "f-content u-text-right f-bold margin-bottom-half"
  }, "Summa:"))), tickets.map(ticket => React.createElement("div", {
    className: "summary-row",
    key: ticket.name
  }, React.createElement("div", {
    className: "box-1"
  }, React.createElement("p", {
    className: "f-content margin-0"
  }, ticket.name)), React.createElement("div", {
    className: "box-2"
  }, React.createElement("p", {
    className: "f-content u-text-right margin-0"
  }, ticket.count)), React.createElement("div", {
    className: "box-3"
  }, React.createElement("p", {
    className: "f-content u-text-right margin-0"
  }, formatCurrency(ticket.totalPrice), " kr")))), React.createElement("div", null, React.createElement("div", {
    className: "summary-row margin-top-2"
  }, React.createElement("p", {
    className: "f-content margin-bottom-half"
  }, "Porto:"), React.createElement("p", {
    className: "f-content margin-bottom-half"
  }, shippingCost, " kr")), React.createElement("div", {
    className: "summary-row"
  }, React.createElement("p", {
    className: "f-content f-bold"
  }, "Betalt:"), React.createElement("p", {
    className: "f-content"
  }, formatCurrency(totalOrderPrice), " kr"))))), React.createElement("div", {
    className: "padding-top-3 padding-bottom-3 bg-white buy-button"
  }, React.createElement(Button, {
    className: "buy-button",
    focus: true,
    onClick: handleBuyTicketsOnClick
  }, "Best\xE4ll fler lotter"))), React.createElement("div", {
    className: "card-background"
  }, confirmationCards.map((_ref3, index) => {
    let {
      buttonText = 'Fortsätt',
      buttonStyle = 'focus',
      image,
      link,
      linkOutsideModule,
      title,
      preamble
    } = _ref3;
    return React.createElement("div", {
      className: index !== confirmationCards.length - 1 ? 'padding-bottom-2' : '',
      key: title
    }, React.createElement(Card, {
      className: "tickets-order-home-media-card-grid h100 padding-1 tickets-order-home-media-card-bg-yellow"
    }, React.createElement(CardBody, {
      className: "u-flex u-flex-column"
    }, React.createElement("div", {
      className: "tickets-order-home-media-card-body-grid margin-bottom-1"
    }, React.createElement("div", {
      className: "f-body"
    }, React.createElement("h2", {
      className: "h2 f-content fw-500 margin-bottom-1"
    }, title), React.createElement("p", {
      className: "p f-content"
    }, preamble)), React.createElement("div", {
      className: "u-flex u-flex-justify-content-center u-flex-align-items-center"
    }, image && React.createElement(Image, {
      image: _objectSpread({}, image)
    }))), React.createElement("div", {
      className: "tickets-order-home-margin-top"
    }, React.createElement(Button, {
      className: "w100",
      [buttonStyle]: true,
      onClick: () => handleCardOnClick({
        link,
        linkOutsideModule
      })
    }, buttonText)))));
  }))));
});

 })(window);